module.exports = __webpack_public_path__ + "static/media/20170806_18day_0846AT.c9082a97.jpg";